export default __webpack_public_path__ + "static/media/letter-a (1).e7ed6245.png";